import React from "react";
import MultiSelectDropdown from "./base/MultiSelectDropdown";
import { CONTRACT_DURATIONS } from "../../../util";

const options = CONTRACT_DURATIONS.map((duration) => ({
  intlValues: { months: duration },
  label: "app.durationInMonth.value",
  value: duration,
}));

const ContractDurations = ({ onChange, onLoad }) => {
  return (
    <MultiSelectDropdown
      title="app.durationInMonth"
      onChange={onChange}
      values={options}
      defaultSelected={CONTRACT_DURATIONS}
    />
  );
};

export default React.memo(ContractDurations);
